const SPACING_BASE = 4;

/** Non-selected item height (theme.spacing multiplier) */
const ITEM_HEIGHT = 10;

/** Selected item / selection band height (theme.spacing multiplier) */
const SELECTED_HEIGHT = 15;

/** Gap between items (theme.spacing multiplier) */
const ITEM_GAP = 1;

/** Scroll slot per item (theme.spacing multiplier) */
const ITEM_SLOT = ITEM_HEIGHT + ITEM_GAP;

/** Picker list container height (theme.spacing multiplier) */
const CONTAINER_HEIGHT = 55;

/** Done button height (theme.spacing multiplier) */
const DONE_BUTTON_HEIGHT = 8;

export const BOTTOM_SHEET_PICKER_CONSTANTS = {
  ITEM_HEIGHT,
  SELECTED_HEIGHT,
  ITEM_GAP,
  ITEM_SLOT,
  CONTAINER_HEIGHT,
  DONE_BUTTON_HEIGHT,
  DONE_BUTTON_PADDING_X: '22.5px',
  DONE_BUTTON_PADDING_Y: '5.5px',
  /** Raw px for imperative scroll calculations in useScrollPicker */
  ITEM_SLOT_PX: ITEM_SLOT * SPACING_BASE,
  VISIBLE_ITEMS: 5,
  FONT_SIZE_LARGE: 22,
  FONT_SIZE_MEDIUM: 16,
  FONT_SIZE_SMALL: 12,
  OPACITY_LARGE: 1,
  OPACITY_MEDIUM: 0.5,
  OPACITY_SMALL: 0.25,
  SCROLL_DEBOUNCE_MS: 150,
  TRANSITION_SETTLE_MS: 50,
} as const;
